import pluralize from 'pluralize'
import { useMemo } from 'react'

// TODO: re-enable Share link as part of the rebrand pass
// import { CopyLink } from 'src/components/atoms/Link/CopyLink'
import { MultiPointMapGeo } from 'src/components/molecules/MultiPointMap/types'
import { ProjectGalleryRebrand } from 'src/components/organisms/ProjectGalleryRebrand'

import {
  GetAdminProjectQuery,
  GetProjectByUriQuery
} from 'src/config/generated/graphql'
import { env } from 'src/env/client.mjs'
import { ArrayElement } from 'src/types/common'
import { GeoData } from 'src/types/map'

import { ProjectContent } from './ProjectContent'
import { ProjectLocations } from './ProjectLocations'

type ViewPublicProjectProps = {
  projectData:
    | ArrayElement<GetProjectByUriQuery['Project']>
    | ArrayElement<GetAdminProjectQuery['Project']>
}

export const ViewPublicProject = ({ projectData }: ViewPublicProjectProps) => {
  const geoData = useMemo(() => {
    const projectGeo: MultiPointMapGeo = {
      ...(JSON.parse(projectData?.Geo || '{}') as GeoData),
      info: {
        title: projectData?.Name!,
        description: projectData?.Applications_aggregate.aggregate?.sum
          ?.Approved
          ? `${
              projectData?.Applications_aggregate.aggregate?.sum?.Approved || 0
            } ${pluralize(
              'tree',
              projectData?.Applications_aggregate.aggregate?.sum?.Approved || 0
            )} received`
          : ''
      }
    }

    return [projectGeo]
  }, [projectData])

  const galleryImages = useMemo(() => {
    const heroImage = projectData.Hero
      ? [
          {
            id: 'hero',
            src: `${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${projectData.Hero}`
          }
        ]
      : []

    return [
      ...heroImage,
      ...projectData.ProjectAssets.map(a => ({
        id: a.Id,
        src: `${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${a.Uri!}`
      }))
    ]
  }, [projectData])

  return (
    <div className='container mx-auto px-4 lg:px-20'>
      <div className='flex flex-col gap-12 lg:gap-24 pt-5 md:pt-10'>
        {/* TODO: re-enable Share link as part of the rebrand pass */}
        {/* <div className='flex flex-row justify-end md:hidden'>
          <CopyLink text='Share' />
        </div> */}
        <ProjectContent
          projectData={projectData}
          rightColumn={<ProjectLocations geoData={geoData} />}
        />
        <ProjectGalleryRebrand images={galleryImages} />
      </div>
    </div>
  )
}
